import { FC, useEffect, useRef, useState } from 'react';
import { Button, Col, Input, InputRef, Row } from 'antd';
import { TbSearch, TbSlash, TbUserPlus } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { useEntitlements } from '@/hooks/useEntitlements';
import { useSlashSearchFocus } from '@/hooks/useSlashSearchFocus';
import { useWorkspaceResources } from '@/hooks/useWorkspaceResources';
import InviteToWorkspaceModal from '@/shared/components/modals/GlobalModals/InviteToWorkspaceModal';
import { useMemberStore } from '@/stores';
import { Member, MemberPermissionType, SetStateMethod } from '@/types';

interface MembersListHeaderProps {
    query: string;
    setQuery: SetStateMethod<string>;
    members: Member[];
    setMembers: SetStateMethod<Member[]>;
}

const MembersListHeader: FC<MembersListHeaderProps> = ({ query, setQuery, members, setMembers }) => {
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);

    const { planTier } = useEntitlements();
    const { selectedMember: member } = useMemberStore();
    const [resourcesCount] = useWorkspaceResources();
    const { token } = useAntDesignTheme();
    const inputRef = useRef<InputRef>(null);

    const disabled =
        member?.permission !== MemberPermissionType.ADMIN && member?.permission !== MemberPermissionType.OWNER;

    useSlashSearchFocus(inputRef, !disabled);

    useEffect(() => {
        setLoading(false);
    }, []);

    return (
        <>
            <Row gutter={[12, 0]}>
                <Col flex='auto'>
                    <Input
                        ref={inputRef}
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                        disabled={disabled}
                        allowClear
                        prefix={<TbSearch style={{ color: token.colorTextQuaternary, marginRight: '0.5rem' }} />}
                        suffix={<TbSlash size='1rem' style={{ color: token.colorTextQuaternary }} />}
                        placeholder='Search Workspace Members...'
                    />
                </Col>
                <Col flex='none'>
                    <Button
                        type='primary'
                        loading={loading}
                        disabled={disabled || (resourcesCount?.members >= 2 && planTier === 'free')}
                        onClick={() => setVisible(true)}
                    >
                        <TbUserPlus style={{ verticalAlign: '-0.175rem' }} />
                        Invite Members
                    </Button>
                </Col>
            </Row>
            <InviteToWorkspaceModal open={visible} setOpen={setVisible} />
        </>
    );
};

export default MembersListHeader;
